import PropTypes from "prop-types";
import clsx from "clsx";
import { Link } from "react-router-dom";

const GOLD = "#c9963a";
const GOLD_LIGHT = "#e8b85c";
const TEXT_MUTED = "rgba(253,248,242,0.65)";
const GOLD_BORDER = "rgba(201,150,58,0.28)";

const FooterOne = ({
  backgroundColorClass,
  spaceTopClass,
  spaceBottomClass,
  spaceLeftClass,
  spaceRightClass,
  containerClass,
  extraFooterClass,
}) => {
  return (
    <>
      <style>{`
        @import url('https://fonts.googleapis.com/css2?family=Cormorant+Garamond:wght@700;800&family=DM+Sans:wght@300;400;500;600&display=swap');

        .footer-main-grid {
          display: grid;
          grid-template-columns: repeat(5, 1fr);
          gap: 30px;
          margin-bottom: 50px;
          text-align: left;
        }

        .footer-social-icons {
          display: flex;
          flex-direction: column;
          gap: 10px;
          justify-content: flex-start;
        }

        .footer-copyright-bar {
          display: flex;
          justify-content: space-evenly;
          align-items: center;
          flex-wrap: wrap;
          gap: 15px;
          text-align: center;
        }

        .footer-links-list {
          list-style: none;
          padding: 0;
          margin: 0;
          text-align: left;
        }

        .footer-links-list li {
          margin-bottom: 10px;
          text-align: left;
        }

        .footer-heading {
          color: ${GOLD};
          font-family: 'DM Sans', sans-serif;
          font-size: 13px;
          font-weight: 600;
          letter-spacing: 0.18em;
          text-transform: uppercase;
          margin-bottom: 20px;
          padding-bottom: 10px;
          border-bottom: 1px solid ${GOLD_BORDER};
          text-align: left;
        }

        @media (max-width: 1200px) {
          .footer-main-grid { gap: 25px; }
        }

        @media (max-width: 992px) {
          .footer-main-grid {
            grid-template-columns: repeat(3, 1fr);
            gap: 30px;
            margin-bottom: 40px;
          }
          .footer-area { padding: 50px 0 0 0 !important; }
        }

        @media (max-width: 768px) {
          .footer-main-grid {
            grid-template-columns: repeat(2, 1fr);
            gap: 30px;
            margin-bottom: 35px;
          }
          .footer-copyright-bar {
            flex-direction: column;
            text-align: center;
            justify-content: center;
          }
          .footer-copyright-bar p { text-align: center !important; }
          .footer-area { padding: 40px 0 0 0 !important; }
          .footer-heading { font-size: 12px; margin-bottom: 15px; padding-bottom: 8px; }
          .footer-links-list li { margin-bottom: 8px; }
          .footer-links-list li a,
          .footer-address-text { font-size: 12px !important; }
        }

        @media (max-width: 576px) {
          .footer-main-grid {
            grid-template-columns: 1fr;
            gap: 30px;
            margin-bottom: 30px;
            text-align: center !important;
          }
          .footer-main-grid > div { text-align: center !important; }
          .footer-heading {
            text-align: center !important;
            font-size: 13px;
            display: inline-block;
            width: auto;
            min-width: 200px;
          }
          .footer-links-list { text-align: center !important; }
          .footer-links-list li { text-align: center !important; }
          .footer-links-list li a { justify-content: center !important; }
          .footer-social-icons { align-items: center !important; }
          .footer-brand-logo {
            margin: 0 auto 18px !important;
            display: inline-block !important;
            text-align: center !important;
          }
          .footer-brand-text { text-align: center !important; }
          .footer-address-text { text-align: center !important; }
          .footer-copyright-bar { flex-direction: column; text-align: center; gap: 10px; }
          .footer-copyright-bar p { font-size: 11px !important; text-align: center !important; }
          .footer-payment-info { justify-content: center !important; }
          .footer-area { padding: 35px 0 0 0 !important; }
          .footer-logo-main { font-size: 22px !important; }
          .footer-logo-sub { font-size: 7px !important; letter-spacing: 0.13em !important; }
        }

        @media (max-width: 375px) {
          .footer-main-grid { gap: 25px; }
          .footer-heading { font-size: 12px; letter-spacing: 0.15em; }
          .footer-links-list li a,
          .footer-address-text { font-size: 11px !important; }
          .footer-social-icons { gap: 8px; }
          .footer-logo-main { font-size: 18px !important; }
          .footer-logo-sub { font-size: 6px !important; letter-spacing: 0.1em !important; }
        }

        @media (max-width: 768px) and (orientation: landscape) {
          .footer-main-grid { grid-template-columns: repeat(3, 1fr); gap: 20px; }
          .footer-area { padding: 30px 0 0 0 !important; }
        }

        @media (min-width: 768px) and (max-width: 992px) and (orientation: landscape) {
          .footer-main-grid { grid-template-columns: repeat(3, 1fr); gap: 25px; }
        }

        @media (min-width: 1920px) {
          .footer-main-grid { gap: 40px; margin-bottom: 60px; }
          .footer-heading { font-size: 15px; margin-bottom: 25px; }
          .footer-links-list li a,
          .footer-address-text { font-size: 14px !important; }
          .footer-logo-main { font-size: 36px !important; }
          .footer-logo-sub { font-size: 11px !important; letter-spacing: 0.28em !important; }
          .footer-copyright-bar p,
          .footer-payment-info span { font-size: 13px !important; }
        }

        @media print {
          .footer-area { display: none !important; }
        }

        @media (prefers-reduced-motion: reduce) {
          .footer-links-list li a,
          .footer-social-icons a { transition: none !important; }
        }
      `}</style>

      <footer
        className={clsx(
          "footer-area",
          backgroundColorClass,
          spaceTopClass,
          spaceBottomClass,
          extraFooterClass,
          spaceLeftClass,
          spaceRightClass
        )}
        style={{
          backgroundColor: "#1e1130",
          borderTop: `1px solid ${GOLD_BORDER}`,
          padding: "60px 0 0px 0",
        }}
      >
        <div className={containerClass || "container"}>
          <div className="footer-main-grid">

            {/* Column 1: Brand & Tagline */}
            <div style={{ textAlign: "left" }}>
              <Link
                to={process.env.PUBLIC_URL + "/"}
                className="footer-brand-logo"
                style={{ display: "inline-block", marginBottom: "18px", textDecoration: "none" }}
              >
                <div
                  className="footer-logo-main"
                  style={{
                    fontFamily: "'Cormorant Garamond', serif",
                    fontSize: 28,
                    fontWeight: 800,
                    letterSpacing: "0.03em",
                    lineHeight: 1,
                    background: "linear-gradient(45deg, #7B5EA7 0%, #C9933A 100%)",
                    WebkitBackgroundClip: "text",
                    WebkitTextFillColor: "transparent",
                    backgroundClip: "text",
                  }}
                >
                  EMARTEBUY
                </div>
                <div
                  className="footer-logo-sub"
                  style={{
                    fontFamily: "'DM Sans', sans-serif",
                    fontSize: 9,
                    letterSpacing: "0.22em",
                    color: TEXT_MUTED,
                    textTransform: "uppercase",
                    fontWeight: 400,
                    marginTop: 6,
                  }}
                >
                  where tradition meets elegance
                </div>
              </Link>
            </div>

            {/* Column 2: Quick Links */}
            <div style={{ textAlign: "left" }}>
              <h3 className="footer-heading">Quick Links</h3>
              <ul className="footer-links-list">
                {[
                  { label: "Home",       to: "/" },
                  { label: "About",      to: "/about" },
                  { label: "Shop",       to: "/shop" },
                  { label: "Contact us", to: "/contact" },
                ].map((item) => (
                  <li key={item.label}>
                    <Link
                      to={process.env.PUBLIC_URL + item.to}
                      style={{
                        fontFamily: "'DM Sans', sans-serif",
                        color: TEXT_MUTED,
                        fontSize: "13.5px",
                        textDecoration: "none",
                        transition: "color 0.2s",
                        display: "inline-flex",
                        alignItems: "center",
                        gap: "6px",
                        textAlign: "left",
                      }}
                      onMouseEnter={(e) => (e.currentTarget.style.color = GOLD_LIGHT)}
                      onMouseLeave={(e) => (e.currentTarget.style.color = TEXT_MUTED)}
                    >
                      <span style={{ fontSize: "11px", color: GOLD, opacity: 0.8, marginRight: "2px" }}>›</span>
                      {item.label}
                    </Link>
                  </li>
                ))}
              </ul>
            </div>

            {/* Column 3: Customer Support */}
            <div style={{ textAlign: "left" }}>
              <h3 className="footer-heading">Customer Support</h3>
              <ul className="footer-links-list">
                {[
                  { label: "Shipping Policy",    to: "/shipping-policy" },
                  { label: "Return Policy",      to: "/return-policy" },
                  { label: "Privacy Policy",     to: "/privacy-policy" },
                  { label: "Terms & Conditions", to: "/terms" },
                ].map((item) => (
                  <li key={item.label}>
                    <Link
                      to={process.env.PUBLIC_URL + item.to}
                      style={{
                        fontFamily: "'DM Sans', sans-serif",
                        color: TEXT_MUTED,
                        fontSize: "13.5px",
                        textDecoration: "none",
                        transition: "color 0.2s",
                        display: "inline-flex",
                        alignItems: "center",
                        gap: "6px",
                      }}
                      onMouseEnter={(e) => (e.currentTarget.style.color = GOLD_LIGHT)}
                      onMouseLeave={(e) => (e.currentTarget.style.color = TEXT_MUTED)}
                    >
                      <span style={{ fontSize: "11px", color: GOLD, opacity: 0.8, marginRight: "2px" }}>›</span>
                      {item.label}
                    </Link>
                  </li>
                ))}
              </ul>
            </div>

            {/* Column 4: Address */}
            <div style={{ textAlign: "left" }}>
              <h3 className="footer-heading">Address</h3>
              <p
                className="footer-address-text"
                style={{
                  fontFamily: "'DM Sans', sans-serif",
                  color: TEXT_MUTED,
                  fontSize: "13.5px",
                  lineHeight: "1.6",
                  margin: 0,
                  textAlign: "left",
                }}
              >
                Shop no 7,<br />
                NSK complex,<br />
                RSP siddhappa chetty street,<br />
                VAO office backside,<br />
                Elampillai - 637502,<br />
                Salem,<br />
                Tamil Nadu
              </p>
            </div>

            {/* Column 5: Social Media — Instagram only */}
            <div style={{ textAlign: "left" }}>
              <h3 className="footer-heading">Social Media</h3>
              <div className="footer-social-icons">
                {[
                  { label: "@ajn_elampillai", url: "https://www.instagram.com/ajn_elampillai/" },
                  { label: "@jst_elampillai", url: "https://www.instagram.com/jst_elampillai/" },
                ].map((account, idx) => (
                  <a
                    key={idx}
                    href={account.url}
                    target="_blank"
                    rel="noopener noreferrer"
                    style={{
                      display: "inline-flex",
                      alignItems: "center",
                      gap: "8px",
                      padding: "7px 14px 7px 11px",
                      borderRadius: "20px",
                      backgroundColor: "transparent",
                      border: "none",
                      color: TEXT_MUTED,
                      textDecoration: "none",
                      fontSize: "12.5px",
                      fontFamily: "'DM Sans', sans-serif",
                      fontWeight: 400,
                      transition: "all 0.2s",
                      width: "fit-content",
                    }}
                    onMouseEnter={(e) => {
                      e.currentTarget.style.color = GOLD_LIGHT;
                    }}
                    onMouseLeave={(e) => {
                      e.currentTarget.style.color = TEXT_MUTED;
                    }}
                  >
                    <i className="fa fa-instagram" style={{ fontSize: "15px" }}></i>
                    {account.label}
                  </a>
                ))}
              </div>
            </div>

          </div>
        </div>

        {/* Bottom Copyright Bar */}
        <div style={{ backgroundColor: "#140b21", padding: "15px 0", borderTop: `1px solid ${GOLD_BORDER}` }}>
          <div className={containerClass || "container"}>
            <div className="footer-copyright-bar">
              <p style={{ fontFamily: "'DM Sans', sans-serif", fontSize: "12px", color: TEXT_MUTED, margin: 0, textAlign: "center" }}>
                Copyright © {new Date().getFullYear()} Emartebuy|All Rights Reserved.
              </p>
            </div>
          </div>
        </div>
      </footer>
    </>
  );
};

FooterOne.propTypes = {
  backgroundColorClass: PropTypes.string,
  containerClass:       PropTypes.string,
  extraFooterClass:     PropTypes.string,
  spaceBottomClass:     PropTypes.string,
  spaceTopClass:        PropTypes.string,
  spaceLeftClass:       PropTypes.string,
  spaceRightClass:      PropTypes.string,
};

export default FooterOne;